<template>
  <section class="keyinvestment">
    <h1 class="keyinvestment__title --fade-in-right" data-vertical-ivp-class="--animate">
      Key Investment Considerations
    </h1>
      <ul class="keyinvestment__content info-list container">
        <li class="info-list__item --fade-in-right --delay-1" data-vertical-ivp-class="--animate">
          <div class="icon-container">
            <img src="../assets/keyinvestment/icon1.png" alt="">
          </div>
          <span>
            <strong>Aspirational Management Team</strong>
              <p>Management team has deep expertise in their field. Aside from the aggregate decades
                of jewelry industry and business management experience, the company is led by individuals
                with world-class knowledge of Ammolite, Ammolite cutting, jewelry manufacturing and distribution.</p>
          </span>
        </li>
        <li class="info-list__item --fade-in-right --delay-1" data-vertical-ivp-class="--animate">
          <div class="icon-container">
            <img src="../assets/keyinvestment/icon2.png" alt="">
          </div>
          <span>
            <strong>Strong Financials</strong>
              <p>For the year ending March 31, 2022 revenues increased 170% year over year,
                while, assets increased by $1,140,240 to $19,215,841 and the company has
                no long term debt.</p>
          </span>
        </li>
        <li class="info-list__item --fade-in-right --delay-1" data-vertical-ivp-class="--animate">
          <div class="icon-container">
            <img src="../assets/keyinvestment/icon3.png" alt="">
          </div>
          <span>
            <strong>Operating with (and Controlling) an Appreciating Asset</strong>
              <p>Ammolite, a rare, opal-like gemstone is the backbone of the company.
                It is a finite resource and its value tends to appreciate. The value
                seeing more than 300% increase over 20 years.</p>
          </span>
        </li>
      </ul>
      <cta/>
  </section>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/keyinvestment.scss';
</style>

<script>
import cta from '@/components/cta.vue';

export default {
  name: 'KeyInvestment',
  components: {
    cta
  },
  data() {
    return {
    };
  },
};
</script>